import React from 'react';
import { Instagram, Facebook, Mail } from 'lucide-react';
import { Card } from '@/components/ui/card';

interface Social {
  email?: string;
  facebook?: string;
  instagram?: string;
}

export interface InstructorProps {
  id: number;
  name: string;
  title: string;
  belt: string;
  bio: string;
  image: string;
  social: Social;
  backgroundImage: string;
}

export const InstructorCard: React.FC<InstructorProps> = ({ 
  name, 
  title, 
  belt, 
  bio, 
  image, 
  social,
  backgroundImage
}) => {
  return (
    <Card className="overflow-hidden shadow-lg relative">
      {/* Background image with opacity */}
      <div 
        className="absolute inset-0 opacity-[0.15] z-0 bg-contain bg-no-repeat bg-bottom md:bg-right" 
        style={{ 
          backgroundImage: `url('/images/smash_cut_sepia/${backgroundImage}')`,
          height: '100%',
          width: '100%'
        }}
      ></div>
      
      <div className="flex flex-col md:flex-row relative z-10">
        <div className="md:w-1/3 bg-gray-100 flex items-center justify-center p-6">
          <img 
            src={image} 
            alt={name} 
            className="w-full object-contain max-h-96"
          />
        </div>
        <div className="md:w-2/3 p-6">
          <div className="inline-block px-3 py-1 text-xs font-medium bg-red-50 text-taekwondo-red rounded-full mb-2">
            {belt}
          </div>
          <h3 className="text-xl font-bold mb-1">{name}</h3>
          <p className="text-gray-500 mb-6">{title}</p>
          
          {/* Bio with paragraph breaks */}
          <div className="text-gray-700 space-y-4">
            {bio.split('\n\n').map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </div>
{/*           
          <div className="flex space-x-3 mt-6">
            {social.email && (
              <a href={`mailto:${social.email}`} className="text-gray-500 hover:text-taekwondo-red transition-colors" aria-label="Email">
                <Mail size={18} />
              </a>
            )}
            {social.facebook && (
              <a href={`https://${social.facebook}`} target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-taekwondo-blue transition-colors" aria-label="Facebook">
                <Facebook size={18} />
              </a>
            )}
            {social.instagram && (
              <a href={`https://${social.instagram}`} target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-purple-600 transition-colors" aria-label="Instagram">
                <Instagram size={18} />
              </a>
            )}
          </div> */}
        </div>
      </div>
    </Card>
  );
};
